import React, { Component } from 'react'

import './style.scss'

class About extends Component {
  render () {
    return (
      <div className="about">
      <a href="../">
        <div className="image"></div>
      </a>
        {/*<div className="bio">*/}
        {/*  Abdul Hakim*/}
        {/*</div>*/}
        <div className="subLink">
          {/*// TODO: replace with blog*/}
          <a href="https://blog.abdulhakimsg.com" className="subLink">
            <h2 className = "subLink">
                BLOG
                {/*<a href="https://drive.google.com/file/d/105007h_JYvHpo52_AKCH47YvP4BJYIDo/view?usp=sharing" download>*/}
                {/* <i className="fa fa-download "></i>*/}
                {/*</a>*/}
          </h2>
          </a>

        </div>
      </div>
    )
  }
}

export default About


// WEBPACK FOOTER //
// ./src/components/Sidebar/About/index.js